const LocalStorageKey = Object.freeze({
    server: "server",
    language: "language",
    lgmSessionId: "LgmSessionId",
    role: "role",
    rememberUsername: "rememberUsername",
    userNo: "userNo",
    displayUserID: "displayUserID",
    accessToken: "accessToken",
    refreshToken: "refreshToken",
    oauth2BackendUrl: "oauth2BackendUrl",
});

export default LocalStorageKey;
